import { z } from 'zod';

import { BatchCustomsStateNotificationType, BatchStatusEnum, SortDirection, TemplateType } from '@e-origin/shared';

export const AdminBatchCriteriaSchema = z.object({
  filters: z
    .object({
      searchQuery: z.string().optional(),
      isExport: z.boolean().optional(),
      templateType: z.nativeEnum(TemplateType).optional(),
      status: z.nativeEnum(BatchStatusEnum).optional(),
      customsReport: z.boolean().optional(),
      filterByUsers: z.array(z.string()).optional(),
      filterByTemplates: z.array(z.string()).optional(),
      filterByCustomers: z.array(z.string()).optional(),
      filterByNotifications: z.array(z.nativeEnum(BatchCustomsStateNotificationType)).optional(),
      integrityCheckDays: z.number().int().nonnegative().optional(),
    })
    .optional(),
  pagination: z.object({
    page: z.number().int().positive(),
    size: z.number().int().positive().max(100),
    currentToken: z.string().optional(),
    searchToken: z.string().optional(),
    direction: z.union([z.literal(-1), z.literal(1)]).optional(),
  }),
  sorting: z.object({
    field: z.string(),
    direction: z.nativeEnum(SortDirection),
  }),
});

export type AdminBatchCriteria = z.infer<typeof AdminBatchCriteriaSchema>;
